__turbopack_context__.v({
  "className": "roboto_mono_7ed1a638-module__-Lewaa__className",
});
